<template>
<div class="row justify-content-center mt-4" v-if="jobType === 'EXPORT' && jobStatus === 'COMPLETE'">
  <template v-if="fileExists">
    <div class="col-2">
      <button class="btn btn-block btn-primary" @click="download">
        <i class="fa fa-download"></i> {{ 'DOWNLOAD' | translate }}
      </button>
    </div>
    <div class="col-2">
      <button class="btn btn-block btn-light text-danger" @click="showConfirmForDeleteExport = true">
        <i class="fa fa-trash-o"></i> {{ 'DELETE' | translate }}
      </button>
    </div>
  </template>
  <template v-else>
    <div class="col-auto">
      <div class="alert alert-warning">
        <span class="fa-stack">
          <i class="fa fa-file-o fa-stack-1x text-warning"></i>
          <i class="fa fa-trash-o fa-stack-1x text-danger icon-bottom-right"></i>
        </span>
        {{ 'MISSING_EXPORT_FILE' | translate('msg') }}
      </div>
    </div>
  </template>

  <confirm-dialog :show="showConfirmForDeleteExport"
                  :textLabel="'msg.SURE_DELETE_FILE'"
                  @hide-dialog="showConfirmForDeleteExport = false"
                  @confirm="deleteFile">
  </confirm-dialog>
</div>
</template>

<script>
import RestService from '../../service/RestService.js';
import ConfirmDialog from '../dialog/ConfirmDialog';

export default {
  components: { ConfirmDialog },
  props: ['jobName', 'jobType', 'jobStatus', 'exportFileExists'],
  data: function() {
    return {
      rest: new RestService(),
      fileExists: this.exportFileExists,
      showConfirmForDeleteExport: false
    }
  },
  methods: {
    download() {
      this.rest.downloadExportFile(this.jobName).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.jobName);
        link.click();
        window.URL.revokeObjectURL(url);
      });
    },
    deleteFile() {
      this.showConfirmForDeleteExport = false;
      this.rest.deleteExportOutput(this.jobName).then((result) => {
        setTimeout(() => {
          this.$notify({
            type: 'alert-success',
            text: 'Bestand ' + this.jobName + ' is succesvol verwijderd.'
          });
        }, 300);
        this.fileExists = false;
      }, (error) => {
        this.$notify({
          type: 'alert-danger',
          duration: -1,
          text: 'Opgeslagen om ' + this.jobName + ' te verwijderen. \n' + error.response ? error.response.data : ''
        });
      });
    }
  }
}
</script>

<style scoped>
  .icon-bottom-right {
    right: -5px;
    bottom: -7px;
    left: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/job/JobDetailsButtons.vue